import request, { METHODS } from "src/utils/api-base";
import { RunAdminReportParams } from "src/types/adminReports.types";

const adminReportsApis = {
  runReport: (params: RunAdminReportParams) => {
    return request({
      route: "/admin/reports",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
};

export default adminReportsApis;
